import React from 'react';
import PropTypes from 'prop-types';
import { checkSetState } from '@teammo/teammo-general-utils';
import history from 'app/routes/history';
import { parseTotal, parsePending, parseCollected } from 'app/utils/parsers';

// Components
import { Card } from 'reactstrap';
import Button from 'app/components/general/Button';
import Tbody from 'app/components/general/Tbody';
import PaymentRow from 'app/components/teamPaymentRequests/PaymentRow';

// Misc

export default class PaymentList extends React.Component {
  static propTypes = {
    payments: PropTypes.any.isRequired,
    getAllPayments: PropTypes.func.isRequired,
    selectPayment: PropTypes.func.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    paymentCollections: PropTypes.any.isRequired,
    totalPaymentCollectionsLoaded: PropTypes.any.isRequired,
    getTotalPaymentCollections: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isLoading: false,
  };

  state = {
    hasLoaded: this.props.hasLoaded || false,
  };

  async componentDidMount() {
    if (!this.props.hasLoaded) {
      await this.props.getAllPayments();
    }
    if (!this.props.totalPaymentCollectionsLoaded) {
      await this.props.getTotalPaymentCollections();
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(checkSetState(this.props, newProps));
  }

  componentDidUpdate(prevProps) {
    if (this.props.payments.length === 0) {
      history.push('/payment-requests/new');
    }
  }

  handleCollect = (e) => {
    e.preventDefault();
    history.push('/payment-requests/new');
  };

  relevantPaymentCollections(paymentId) {
    return this.props.paymentCollections.filter(
      (t) => (t.payment.id === paymentId && t.status !== 'cancelled'),
    );
  }

  render() {
    const listPayments = this.props.payments.map((payment) => (
      <PaymentRow
        key={payment.id}
        payment={payment}
        team={payment.team}
        amount={payment.amount}
        selectPayment={this.props.selectPayment}
        total={parseTotal(payment, this.relevantPaymentCollections(payment.id))}
        pendingTeamMembers={parsePending(
          payment,
          this.relevantPaymentCollections(payment.id),
        )}
        collectedTeamMembers={parseCollected(
          payment,
          this.relevantPaymentCollections(payment.id),
        )}
        payments={0}
      />
    ));
    if (this.state.hasLoaded && this.props.payments.length > 0) {
      return (
        <Card className="">
          <div className="row card-title">
            <div className="col col-6 col-md-8 card-title-col">
              <span>Payments</span>
            </div>
            <div className="col col-6 col-md-4 btn-flex-group">
              <div className="btn-flex-container">
                <Button
                  className="btn-thinner btn-thin-margin btn-success"
                  isLoading={this.props.isLoading}
                  onClick={this.handleCollect}
                >
                  Request Payment
                </Button>
              </div>
            </div>
          </div>
          <div className="row head-row">
            <div className="col col-5">Description</div>
            <div className="col col-2">Amount</div>
            <div className="col col-2">Collected</div>
            <div className="col col-2">Total</div>
            <div className="col col-1" />
          </div>
          <Tbody name="payments">{listPayments}</Tbody>
        </Card>
      );
    }
    return null;
  }
}
